// looks for property in props.
// If not found directly, tries to find it in props.format.
export default propertyName => (state, props) => {
  let value = props[propertyName];
  if (value === undefined && props.format !== undefined) {
    value = props.format[propertyName];
  }
  return value;
};